export default function Hero() {
  const stats = [
    { value: '24h 不间断', label: '实时追踪更新' },
    { value: '10万+', label: '每日活跃瓜友' },
    { value: '全网首发', label: '独家爆料速度' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20Chinese%20entertainment%20gossip%20news%20theme%20background%20with%20warm%20coral%20red%20and%20gold%20gradient%20tones%2C%20bold%20geometric%20shapes%2C%20magazine%20editorial%20style%2C%20vibrant%20dynamic%20composition%2C%20no%20text%2C%20clean%20artistic%20aesthetic%2C%20high%20contrast%20between%20warm%20reds%20and%20deep%20charcoal%20shadows&width=1920&height=1080&seq=hero-bg-baogua-2026&orientation=landscape"
          alt="爆瓜网娱乐资讯背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="px-3 py-1 rounded-full text-xs font-medium bg-accent-500/80 text-background-50 whitespace-nowrap">
                全网热点
              </span>
              <span className="px-3 py-1 rounded-full text-xs font-medium bg-primary-400/80 text-background-50 whitespace-nowrap">
                每日速递
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-background-50 mb-4 leading-tight">
              爆瓜网 · 吃瓜爆料第一站
            </h1>

            <p className="text-lg md:text-xl text-background-50/90 font-body font-light mb-3">
              全网最新鲜的瓜，都在这里等你来吃
            </p>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              爆瓜网官网入口直达，每日汇聚全网吃瓜爆料、明星八卦、热门事件及娱乐资讯。
              从娱乐圈最新动态到社会热点追踪，一站速递全部精彩。无论是最新的大瓜还是经典回味，
              这里都是资深瓜友的每日必刷。当前热榜持续刷新，收藏爆瓜网，吃瓜快人一步。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading text-accent-400">{s.value}</div>
                  <div className="text-xs text-background-50/60 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                立即吃瓜
              </a>
              <a
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-6 py-3 border border-background-50/40 text-background-50 rounded-full font-medium text-sm whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer"
              >
                查看最新快讯
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[280px] md:w-[380px] md:h-[380px] lg:w-[420px] lg:h-[420px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20gossip%20magazine%20collage%20style%20with%20abstract%20paparazzi%20camera%20flashes%2C%20vibrant%20warm%20red%20coral%20and%20gold%20tones%2C%20bold%20editorial%20design%2C%20dynamic%20energy%2C%20modern%20Chinese%20pop%20culture%20aesthetic%2C%20celebrity%20news%20vibe%2C%20clean%20composition%20on%20dark%20background%2C%20no%20recognizable%20faces&width=840&height=840&seq=hero-main-baogua-2026&orientation=squarish"
                alt="爆瓜网吃瓜爆料主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-background-50/20"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}